<template>
    
    <transition name="fade">
    <div class="dates-pop-up" v-if="showPopUp" key="modal">
  
      <div class="dates-pop-up__container">
        <div class="dates-pop-up__close">
          <span
            @click="closePopUp"
            v-on:keyup.enter="closePopUp"
            tabindex="0"
            aria-label="Zamknij"
          >
          </span>
        </div>
        <div class="dates-pop-up__content">
          <p tabindex="0" aria-label="Wybierz datę notowania">
            Wybierz datę notowania
          </p>
          <div class="dates-pop-up__date-select">
            <DatesInputs
              :dateData="allYears"
              :firstItem="actualYear"
              isActive="true"
              v-on:dateValue="
                value => {
                  changeActualYear(value);
                }
              "
              tabindex="0"
              aria-label="Wybierz rok"
            />
            <DatesInputs
              :dateData="months"
              :firstItem="showMonth"
              isActive="true"
              v-on:dateValue="
                value => {
                  makeDateValue(value);
                }
              "
              tabindex="0"
              aria-label="Wybierz miesiąc"
            />
            <DatesInputs
              :dateData="allDays"
              :firstItem="actualDay"
              :isActive="activeDay"
              v-on:dateValue="
                value => {
                  emitDay(value);
                }
              "
              tabindex="0"
              aria-label="Wybierz dzień"
            />
          </div>
          <div class="dates-pop-up__button-container">
            <SelectButton buttonName="pokaż notowanie" :action="sendInfoToList" />
          </div>
          <div
            class="dates-pop-up__cancel-button"
            @click="closePopUp"
            v-on:keyup.enter="closePopUp"
            tabindex="0"
            aria-label="anuluj"
          >
            anuluj
          </div>
        </div>
      </div>
   
    </div>
       </transition>

</template>

<script>
import DatesInputs from "@/ui/DateSelectPopUp.vue";
import SelectButton from "@/ui/SelectButton.vue";
import mixin from "../mixin";

export default {
  mixins: [mixin],
  components: {
    DatesInputs,
    SelectButton
  }
};
</script>

<style scoped lang="scss">
.dates-pop-up {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  &__date-select {
    width: 80%;
    display: flex;
    justify-content: space-around;
    margin: 2rem 0 1rem 0;
  }
  &__container {
    width: 31.25rem;
    height: 19.75rem;
    background-color: #fff;
    border-radius: 5px;
  }
  &__close {
    width: 100%;
    height: 3rem;
    background-color: #af2f82;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    color: #c5d0ee;
    font-weight: 700;
    font-size: 2rem;
    padding: 0 2rem;
    box-sizing: border-box;
    text-align: end;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    position: relative;
    & span {
      color: #fff;
      font-size: 30px;
      position: absolute;
      top: 1rem;
      right: 1rem;
      cursor: pointer;

      width: 1.25rem;
      height: 1.25rem;
      display: block;
      background-image: url("~@/assets/loginModal__close.png");
      background-size: cover;
      background-position: center;
    }
  }
  &__content {
    height: 16.75rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Poppins", sans-serif;
    flex-direction: column;
  }
  &__cancel-button {
    font-family: "Poppins", sans-serif;
    font-size: 0.9rem;
    color: #0f1626;
    text-transform: uppercase;
    cursor: pointer;
  }
  &__button-container {
    width: 12.125rem;
  }
}
</style>
<style>

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>